import React, { memo } from 'react'

import {
  Button, Icon, Refresh, BrushAI, AIGeneratedGradientFilled,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, number, shape, string } from 'prop-types'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import DownloadButton from './Components/DownloadButton/DownloadButton'

const applyIcon = <Icon svgComponent={AIGeneratedGradientFilled} size={iconSize} notSpaced />
const regenerateIcon = <Icon svgComponent={Refresh} size={iconSize} notSpaced />
const editIcon = <Icon svgComponent={BrushAI} size={iconSize} notSpaced />

// Completed turn: the generated image and the apply / regenerate / edit / download actions.
function Result({ result, isGenerating, onApply, onRegenerate, onEdit }) {
  const t = useTranslation()

  return (
    <div className="image-assistant-create-tab__result">
      <div className="image-assistant-create-tab__result-image-wrapper">
        <img className="image-assistant-create-tab__result-image" src={result.url} alt={result.alt} />
      </div>
      <div className="image-assistant-panel__actions image-assistant-create-tab__result-actions">
        <Button
          type="secondary"
          size="small"
          variant="with-icon"
          customClass="image-assistant-panel__action image-assistant-panel__action--ai"
          icon={applyIcon}
          onClick={onApply}
        >
          <span className="image-assistant-panel__action-label cgt-body-base-semibold">
            {t('imageAssistantPanel.actions.useForThreeDGeneration')}
          </span>
        </Button>
        <Button
          type="secondary"
          size="small"
          variant="with-icon"
          customClass="image-assistant-panel__action"
          icon={regenerateIcon}
          disabled={isGenerating}
          onClick={onRegenerate}
        >
          {t('imageAssistantPanel.actions.regenerate')}
        </Button>
        <Button
          type="secondary"
          size="small"
          variant="with-icon"
          customClass="image-assistant-panel__action"
          icon={editIcon}
          onClick={onEdit}
        >
          {t('imageAssistantPanel.actions.editImage')}
        </Button>
        <DownloadButton result={result} />
      </div>
    </div>
  )
}

Result.propTypes = {
  result: shape({ id: number, url: string, alt: string }).isRequired,
  isGenerating: bool.isRequired,
  onApply: func.isRequired,
  onRegenerate: func.isRequired,
  onEdit: func.isRequired,
}

export default memo(Result)
